import { JOB_LISTING_STATE } from '~/features/xstateSystem';
import { createListingStepMachine } from '../../../step-machine/listingStep.machine';
import { API_CALLS } from './api';
import { BasicInfoFormValues } from './types';

// [MCV-1523] This step PATCHes the listing itself, not a detail record, so its
// response has to land on `context.listing` via the parent's `updateListing`.
// Routing it through ON_UPDATE_DETAIL merged it into `listing.detail` and left
// aoiSpecialtyId/specialtyName stale — Provider Specialty came back empty on
// back-navigation.
export const basicInfoMachine = createListingStepMachine<BasicInfoFormValues>(
  API_CALLS.patch,
  JOB_LISTING_STATE,
  API_CALLS.create,
  'ON_ADD_LISTING',
  'ON_UPDATE_LISTING'
);
